var _circle, _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdunitNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 127,
    viewBox: "0 0 103 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 75.5,
    r: 51,
    stroke: "#CED4DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 1,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#CED4DA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2402 59.6602C26.2402 59.1079 26.6879 58.6602 27.2402 58.6602H50.4844V56.6602H27.2402C25.5834 56.6602 24.2402 58.0033 24.2402 59.6602V87.8716H26.2402V59.6602ZM72.2803 61.4835H29.9993C29.7232 61.4835 29.4993 61.7074 29.4993 61.9835V95.6472C29.4993 95.9233 29.7232 96.1472 29.9993 96.1472H72.2803C72.5565 96.1472 72.7803 95.9233 72.7803 95.6472V61.9835C72.7803 61.7074 72.5565 61.4835 72.2803 61.4835ZM29.9993 59.9835C28.8948 59.9835 27.9993 60.879 27.9993 61.9835V95.6472C27.9993 96.7518 28.8948 97.6472 29.9993 97.6472H72.2803C73.3849 97.6472 74.2803 96.7518 74.2803 95.6472V61.9835C74.2803 60.879 73.3849 59.9835 72.2803 59.9835H29.9993ZM55.5 99.5H46.5V103.5H55.5V99.5ZM46.5 98H45V99.5V103.5V105H46.5H55.5H57V103.5V99.5V98H55.5H46.5Z",
    fill: "#CED4DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1074 21.4575L51.9174 24.7635V14H50.0841V24.7635L46.8941 21.4575L45.6016 22.797L51.0007 28.402L56.3999 22.797L55.1074 21.4575Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1667 24.877V30.8905H41.8333V24.877H40V32.7905H62V24.877H60.1667Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 26,
    y: 0,
    width: 51,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdunitNodata);
export default __webpack_public_path__ + "static/media/adunit_nodata.e084d40bc1386b52837c9e89ff8b20c7.svg";
export { ForwardRef as ReactComponent };